import { ActionTypesMyRecentActivities } from './constants';
import { MyRecentActivitiesInitialStateType, MyRecentActivitiesAPIType } from './types';

const initialState: MyRecentActivitiesInitialStateType = {
  myRecentActivitiesData: [] as MyRecentActivitiesAPIType[],
  isMyRecentActivitiesDataLoading: false,
};

function myRecentActivitiesReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypesMyRecentActivities.SET_MY_RECENT_ACTIVITIES_DATA:
      return {
        ...state,
        myRecentActivitiesData: action.gridData,
      };
    case ActionTypesMyRecentActivities.TOGGLE_IS_MY_RECENT_ACTIVITIES_DATA_LOADING:
      return {
        ...state,
        isMyRecentActivitiesDataLoading: action.isLoading,
      };
    default:
      return state;
  }
}

export default myRecentActivitiesReducer;
